import { CartaoPeriodoPadrao } from '../shared/enums/cartao-periodo-padrao.enum';

export class CreateCard {
    public cardId: number;
    public assignorContractId: number;
    public assignorContractsId: number[];
    public referenceValue: number;
    public regularityId: CartaoPeriodoPadrao;
    public productGuid: string;
    public productCategory: number;
    public active: boolean;
    public suspend: boolean;
    constructor() { }
}
